export const sharedFieldOrder = {
    summary: 10,
    occurredAt: 20,
    description: 30,
    locationScope: 40,
    locationSites: 41,
    locationFootprint: 42,
    locationProjectName: 43,
    reportedByFunction: 50,
    thirdPartyInvolved: 60,
    potentialImpactOnAnotherIncidentCategory: 70,
    customerPriority: 75,
    attachments: 80,
} as const;
